import CryptoJS from 'crypto-js';
import Swal from 'sweetalert2';
import { safeBtoa } from '@root/private/js/lib/crypto.util';

export const isHls = () => window.location.pathname.includes('hls');

export const generateExtraSecureKey = (label: string): string => {
  return CryptoJS.MD5(label).toString();
};

export const decryptKey = (secureKey: string, secretKey: string): string => {
  const encodedSecretKey = safeBtoa(secretKey);
  if (encodedSecretKey === null) {
    return '';
  }

  try {
    return CryptoJS.AES.decrypt(
      secureKey,
      CryptoJS.enc.Base64.parse(encodedSecretKey),
      { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 },
    )
      .toString(CryptoJS.enc.Utf8)
      .trim();
  } catch {
    return '';
  }
};

export const parseDecryptedData = (
  decrypted: string,
  isExtraSecure: boolean,
): [string, string, string?] => {
  const [playKey, expire, action = 'wc'] = decrypted.split('|');
  return [playKey, expire, isExtraSecure ? action.toLowerCase() : undefined];
};

export const openSwal = ({
  icon,
  title,
  message,
}: {
  icon: 'error';
  title: string;
  message: string;
}) => {
  return Swal.fire({
    icon,
    title,
    text: message,
    allowEscapeKey: false,
    allowOutsideClick: false,
    showConfirmButton: false,
  });
};

export const isLabelExists = Boolean(
  new URLSearchParams(window.location.search).get('label'),
);

export const isSecurePlayer = () => {
  const paths = window.location.pathname.split('/');
  return ['secure', 'secure_ext'].includes(paths[paths.length - 1]);
};
